import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Game from './pages/Game';
import Login from './pages/Login';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Hostess from './pages/Hostess';
import Sessions from './pages/Sessions';
import Stocks from './pages/Stocks';
import Prizes from './pages/Prizes';
import Participants from './pages/Participants';
import DailyQuotas from './pages/DailyQuotas';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/home" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/hostess" element={<Hostess />} />
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/stocks" element={<Stocks />} />
          <Route path="/prizes" element={<Prizes />} />
          <Route path="/participants" element={<Participants />} />
          <Route path="/daily-quotas" element={<DailyQuotas />} />
          <Route path="/game/:token" element={<Game />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
